import { chartHelper } from 'helpers';
import { Box, ErrorFormField, Sidebar } from 'components/common';
import { ELSButton, ELSFlex, ELSFlexItem } from 'components/common/els';
import { ChartViewProps } from 'components/features/shared/constants';
import { BLOCK, TransfusionDetailsFormField, VITAL_SIGN_CONFIGS, getPlaceholderClass } from './constants';
import SidebarActions from './SidebarActions';

export interface TransfusionDetailsSidebarViewProps extends Partial<ChartViewProps> {
  isSidebarOpen: boolean;
  onCloseClick: Function;
  sidebarProps: Function;
}

const TransfusionDetailsSidebarView = (props: TransfusionDetailsSidebarViewProps) => {
  const { formFieldMap, formSubmittedCount, isSidebarOpen, onCloseClick, sidebarProps } = props;
  const handleClose = () => chartHelper.handleCloseSidebar({ sidebarProps, onCloseClick });

  const renderField = (fieldName: string, hasRightPadding = false) => {
    const formField = formFieldMap.get(fieldName);

    return (
      <ELSFlexItem w="1o2" md="1o1">
        <div className={getPlaceholderClass(formField)}>
          <ErrorFormField className={hasRightPadding ? 'u-els-padding-right' : undefined} formField={formField} formSubmittedCount={formSubmittedCount} />
        </div>
      </ELSFlexItem>
    );
  };

  return (
    <Sidebar open={isSidebarOpen} onClose={handleClose} sidebarProps={sidebarProps} hideCloseButton>
      <ELSFlex className={`${BLOCK}__sidebar-header`} middle spaceBetween>
        <ELSFlexItem>
          <h2>Add Transfusion Details</h2>
        </ELSFlexItem>
        <ELSFlexItem>
          <ELSButton type="debuttonize" ariaLabel="Close" iconName="close" iconPrefix="hmds" iconSize="1x" onClick={handleClose} />
        </ELSFlexItem>
      </ELSFlex>
      <Box className={`${BLOCK}__sidebar-form`}>
        <Box className={`${BLOCK}__sidebar-group`}>
          <ELSFlex left wrap className="u-els-margin-bottom">
            {renderField(TransfusionDetailsFormField.DAY, true)}
            {renderField(TransfusionDetailsFormField.TIME_BEGUN)}
          </ELSFlex>
          <ELSFlex left wrap>
            {renderField(TransfusionDetailsFormField.TIME_COMPLETED, true)}
          </ELSFlex>
        </Box>

        {VITAL_SIGN_CONFIGS.map((vitalSign) => (
          <Box key={vitalSign.label} className={`${BLOCK}__sidebar-group`}>
            <h4 className={`${BLOCK}__sidebar-group-title`}>{vitalSign.label}</h4>
            <ELSFlex left wrap className="u-els-margin-bottom">
              {renderField(vitalSign.beforeField, true)}
              {renderField(vitalSign.fifteenMinutesField)}
            </ELSFlex>
            <ELSFlex left wrap>
              {renderField(vitalSign.immediatelyAfterField, true)}
            </ELSFlex>
          </Box>
        ))}
        <Box className={`${BLOCK}__sidebar-actions`}>
          <SidebarActions {...props.chartActionsProps} />
        </Box>
      </Box>
    </Sidebar>
  );
};

export default TransfusionDetailsSidebarView;
